export default class LiveStreamMiniPlayer {
  constructor(component) {
    this.dom = {
      $component: component,
    }

    this.mount()
  }

  mount() {
    const { shopName } = this.dom.$component.dataset
    new window.VideeoSDK('js-live-stream-mini-player-container', {
      shopName,
      miniPlayer: true,
    })
  }
}
